module.exports = __webpack_public_path__ + "img/sage.cc0493b6.png";